<template>
  <Div class="maintain">
    <MyTransition :myName="'up'">
      <Popup v-if="popupStatus">
        <PopupCheck
          v-if="popup == 'check'"
          :text="successText"
          @go="popupAction"
          @cancel="poupupEnter"
        ></PopupCheck>
        <PopupSuccess
          v-if="popup == 'success'"
          :text="successText"
          @check="poupupEnter"
        ></PopupSuccess>
        <PopupError
          v-if="popup == 'error'"
          :text="successText"
          @check="poupupEnter"
        ></PopupError>
      </Popup>
    </MyTransition>
    <div class="addCourse">
      <button class="btn_primary" @click="goAdd">新增區域</button>
    </div>
    <div class="list contain_white">
      <!-- 一般 -->
      <table>
        <thead>
          <tr>
            <th v-for="(th, index) in table_thead" :key="index">
              {{ th.label }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data" :key="index">
            <template v-for="(th, i) in table_thead">
              <td v-if="th.value == 'action'" :key="`action_${i}`">
                <div class="action flex">
                  <div @click="edit(item, index)">
                    <i class="el-icon-edit-outline"></i>
                  </div>
                  <div @click="del(item, index)">
                    <i class="el-icon-delete"></i>
                  </div>
                </div>
              </td>
              <td
                v-else-if="Array.isArray(item[th.value]) && item[th.value]"
                :key="`object_${i}`">
                <template v-for="(p) in item[th.value]" >
                  {{p.name}}
                </template>
              </td>
              <td
                v-else-if="typeof item[th.value] == 'object' && item[th.value]"
                :key="`object_${i}`"
              >
                {{ item[th.value].name }}
              </td>
              <td
                v-else-if="item[th.value] && th.value == 'department_id'"
                :key="`deaprtment_${i}`"
              >
                {{
                  transformLabel({
                    data: item[th.value],
                  })
                }}
              </td>
              <td v-else :key="`other_${i}`">
                {{ item[th.value] }}
              </td>
            </template>
          </tr>
        </tbody>
      </table>
    </div>
  </Div>
</template>
<style lang="scss">
.maintain {
  .list {
    margin: 20px 0;
    table {
      width: 100%;
      .action {
        flex: 1;
        > div {
          cursor: pointer;
          background: #efefef;
          padding: 4px;
          border-radius: 3px;
          margin: 0 10px 0 0;
          i {
            color: #777;
          }
          &:hover {
            transform: scale(1.1);
            color: #fff;
            background: var(--mainColor);
            i {
              color: #fff;
            }
          }
        }
      }
      th {
        border-bottom: 1px solid #ebeef5;
        font-weight: bold;
        padding: 0 10px 15px 10px;
        font-size: 14px;
      }
      td {
        padding: 10px 10px;
        border-bottom: 1px solid #ebeef5;
        font-size: 14px;
      }
    }
  }
}
</style>
<script>
export default {
  name: "location",
  data() {
    return {
      data: [],
      table_thead: [
        {
          label: "操作",
          value: "action",
        },
        {
          label: "工作區域",
          value: "location",
        },
        {
          label: "單位",
          value: "department_id",
        },
        {
          label: "部門主管(平日)",
          value: "admin",
        },
        // {
        //   label: "部門主管(假日)",
        //   value: "admin_h",
        // },
        {
          label: "備註",
          value: "remark",
        },
      ],
      options: {
        department: [],
      },
      popupStatus: false,
      successText: null,
      popup: null,
      actionIndex: null,
    };
  },
  created() {
    this.getDepartment();
    this.getData();
  },
  methods: {
    goAdd() {
      this.$router.push({
        path: "location/loaction_detailed",
      });
    },
    getData() {
      this.$http.api.admin.location().then((res) => {
        this.data = res.data;
      });
    },
    del(item, index) {
      this.actionIndex = item.id;
      this.popupStatus = true;
      this.successText = "確定刪除嗎";
      this.popup = "check";
    },
    edit(item, index) {
      this.$router.push({
        path: "location/loaction_detailed",
        query: {
          id: item.id,
        },
      });
    },
    popupAction() {
      this.$http.api.admin
        .delLocation(this.actionIndex)
        .then((res) => {
          this.popupStatus = true;
          this.successText = "成功";
          this.popup = "success";
        })
        .catch((error) => {
          this.popupStatus = true;
          this.popup = "error";
          this.successText = "刪除失敗";
        });
    },
    poupupEnter() {
      this.popupStatus = false;
      this.getData();
    },
    getDepartment() {
      this.$http.api.admin.department().then((res) => {
        this.options.department = res.data;
      });
    },
    transformLabel({ data }) {
      const item = this.options.department.find((el) => {
        return el.department_id == data;
      });
      return item&&item.department;
    },
    cancelSticky(item, index) {},
  },
};
</script>